const mensajes = {
    // CampoCodigoDocumentoBase
    'DocumentoBuscador.CampoCodigoDocumentoBase.Nombre': 'Código documento base',
    'DocumentoBuscador.CampoIdentificacionCliente.Nombre':'Identificación cliente',
    'DocumentoBuscador.CampoFactura.Factura':'Factura'
};

export default mensajes;
